/**
 * @desc 导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.salesOwnerInfo.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/salesOwnerInfo/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
